import React, { use, useEffect } from "react";

import { wrap } from "./RydTestbedWrap";
import {Tone,} from "../model/core";
import {
    IntervalPattern,
    Scale,
} from "../model/scales";
import { RydToneMultiSelectKeybed } from "../components/rolls/PianoKeybed";
import { findMatchingScales } from "../services/ScaleIdentifyier";

export function ScaleIdentifyierTestbed() {
    const [inputTones, setInputTones] = React.useState<Tone[]>([]);
    const [matchingScales, setMatchingScales] = React.useState<Scale[]>([]);

    useEffect(() => {
        setMatchingScales(findMatchingScales(
            [
                // Example patterns, you can add more or modify these
                new IntervalPattern("Major", [2, 2, 1, 2, 2, 2]),
                new IntervalPattern('minor', [2, 1, 2, 2, 1, 2]),
            ],
            inputTones
        ));
    }, [inputTones]);

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>ScaleIdentifyier Testbed</h1>
        <table>
            <tbody>
                <tr><td>input</td>
                    <td>
                        <RydToneMultiSelectKeybed
                            tones={inputTones}
                            setSelectedTones={setInputTones}
                            stylingSource={(n) => inputTones.includes(n) ? 'in' : 'out'}
                        />
                    </td>
                    <td>state:
                        <ul>
                            {inputTones.map((t, i) => <li key={i}>{t.getName()}</li>)}
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>matching scales</td>
                    <td colSpan={2}>
                        <table>
                            <tbody>
                                {matchingScales.map((s, i) => (
                                    <tr key={i}>
                                        <td>{s.name}</td>
                                        <td>{s.pattern.pattern.intervals}</td>

                                        {s.tones.map((d, j) => (
                                            <td key={j}>{d.getName()}</td>
                                        ))}

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </>);
}